/* import __COLOCATED_TEMPLATE__ from './deposit-account-info-modal-content.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { InstantAccessProgram } from '@square/dashboard-protos/models/squareup/inflows/instant_access_program_model';
import { tracked } from '@glimmer/tracking';
import { formatNumber } from '@banking/ui/utils/checking/utils';
const DOORDASH_LABEL = 'DoorDash';
const UBER_EATS_LABEL = 'Uber Eats';
let DepositAccountInfoModalContent = (_class = class DepositAccountInfoModalContent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "accountNumberCopied", _descriptor, this);
    _initializerDefineProperty(this, "routingNumberCopied", _descriptor2, this);
  }
  get platformLabel() {
    if (this.args.selectedPlatformLabel) {
      return this.args.selectedPlatformLabel;
    }
    switch (this.args.selectedIntegration?.platform) {
      case InstantAccessProgram.Platform.DOORDASH:
        return DOORDASH_LABEL;
      case InstantAccessProgram.Platform.UBER_EATS:
        return UBER_EATS_LABEL;
      default:
        return '';
    }
  }
  get formattedAccountNumber() {
    return formatNumber(this.args.directDepositAccountInfo?.accountNumberFull, [9, 6, 3]);
  }
  get formattedRoutingNumber() {
    return formatNumber(this.args.directDepositAccountInfo?.routingNumber, [6, 3]);
  }
  async copyToClipboard(text, setCopied) {
    await window.navigator?.clipboard.writeText(text);
    setCopied(true);

    // Reset the copied state after 1 second
    later(this, () => {
      setCopied(false);
    }, 1000);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "accountNumberCopied", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "routingNumberCopied", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "copyToClipboard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyToClipboard"), _class.prototype), _class);
export { DepositAccountInfoModalContent as default };